import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// A card title that truncates with a fade-out (instead of overflowing into a neighboring card)
// when the name is too long for one line, with a small chevron to expand the box downward and
// show the rest of the name — collapses back to the compact single line when pressed again.
export function ExpandableTitle({ text, testId }) {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth + 1);
  }, [text]);

  return (
    <div className="flex items-start gap-1 mb-1">
      <h3
        ref={ref}
        data-testid={testId}
        className={`font-display text-2xl flex-1 min-w-0 ${expanded ? "whitespace-normal break-words" : "whitespace-nowrap overflow-hidden"}`}
        style={
          !expanded
            ? { WebkitMaskImage: "linear-gradient(to right, black 88%, transparent 100%)", maskImage: "linear-gradient(to right, black 88%, transparent 100%)" }
            : undefined
        }
      >
        {text}
      </h3>
      {isTruncated && (
        <button
          data-testid={testId ? `${testId}-toggle` : undefined}
          onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
          className="shrink-0 mt-1.5 text-[#f1e0c5]/40 hover:text-[#D4AF37] transition-colors duration-200"
          title={expanded ? "Show less" : "Show full name"}
        >
          <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} />
        </button>
      )}
    </div>
  );
}
